module.exports = __webpack_public_path__ + "img/footer_cam.1193afee.svg";